module.exports = __webpack_public_path__ + "8cc7b1b847b300445c35aec17f09ad02.png";